import type { Task } from '../../api/tasks.ts';
import { closedLine } from '../../tasks/closedLine.ts';

/**
 * One closed task on a client's Tasks section (A-#211 fix 2). A button: it opens the task card, as TaskRow does. No
 * priority word, no due date and no overdue mark on a closed task; the line says how it closed.
 */
export function ClosedTaskRow({ task: t, onOpen }: { task: Task; onOpen: (id: string) => void }) {
  return (
    <li data-task-id={t.id}>
      <button type="button" onClick={() => onOpen(t.id)}
              className="flex min-h-[64px] w-full gap-3 px-4 py-3 text-left hover:bg-neutral-50 active:bg-neutral-100 lg:items-center lg:px-5">
        <span className="min-w-0 flex-1">
          <span className="font-semibold text-neutral-900">{t.title}</span>
          <span className="mt-0.5 block text-sm text-neutral-700">
            {t.department} · {t.assigned_to ? t.assigned_to.name : 'Unassigned: the queue'}
          </span>
          <span className="mt-0.5 block text-[0.9375rem] text-neutral-800">{closedLine(t)}</span>
        </span>
      </button>
    </li>
  );
}
